
// You can write more code here

/* START OF COMPILED CODE */

import EditorPlatformMarker from "../../level/EditorPlatformMarker";
import PositionMarker from "../../level/editor/PositionMarker";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class MoverData {

  constructor(gameObject: EditorPlatformMarker) {
    this.gameObject = gameObject;
    (gameObject as any)["__MoverData"] = this;

    /* START-USER-CTR-CODE */
    this.gameObject.isMovingPlatform = true;
    /* END-USER-CTR-CODE */
  }

  static getComponent(gameObject: EditorPlatformMarker): MoverData {
    return (gameObject as any)["__MoverData"];
  }

  private gameObject: EditorPlatformMarker;
  public startMarker!: PositionMarker;
  public endMarker!: PositionMarker;
  public startWait: number = 0;
  public endWait: number = 0;
  public initialDelay: number = 0;

  /* START-USER-CODE */

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
